import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBelangrijkeDocumenten = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="m9.32 31.66 17.83 2.44 2.78-20.24.38-2.77.37-2.75L18.2 6.63l-5.35-.73-.76 5.52z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="M11 33h18V7H11v26"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M23 10.5H13v1h10zM22 13.5h-9v1h9zM22 21.5h-9v1h9zM19 24.5h-6v1h6z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBelangrijkeDocumenten);

export default ForwardRef;
